// extracted by mini-css-extract-plugin
module.exports = {"select":"styles_select__wrQ_d","control":"styles_control__m8E_p","custom-scroll__menu-list":"styles_custom-scroll__menu-list__bCqD_"};